export default "/fonts/parisienne-regular-webfont.svg?dfa263781c07b87f88149915d0047074";